<template>
  <div class="radio-list-filter">

    <div
      class="radio-list-filter__header"
      role="button"
      tabindex="0"
      @click="toggle"
      @keyup.enter="toggle"
      @keydown.space.prevent="toggle"
    >
      <span class="radio-list-filter__title">{{ config.name }}</span>
      <span class="sr-only">, </span>
      <span class="radio-list-filter__icon" :aria-label="collapseAriaLabel">{{ isOpen ? '−' : '+' }}</span>
    </div>

    <div v-show="isOpen" class="radio-list-filter__body" role="radiogroup" :aria-label="config.name">
      <span :id="hintId" class="sr-only">{{ content.chooseOptionHint }}</span>
      <label
        v-for="item in _config.items"
        :key="item.value"
        class="radio-list-filter__item"
      >
        <input
          type="radio"
          :name="config.name"
          :checked="item.selected"
          :aria-describedby="hintId"
          :aria-labelledby="itemLabelId(item)"
          @change="onSelect(item)"
        />
        <span :id="itemLabelId(item)" aria-hidden="true">{{ item.label }}</span>
      </label>
    </div>

  </div>
</template>

<script>
import featureMixin from "@/mixins/featureMixin";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "RadioListFilter",
  mixins: [featureMixin],

  computed: {
    ...mapGetters("filters", ["activeAccordionSections"]),

    isOpen() {
      return (
        Array.isArray(this.activeAccordionSections) &&
        this.activeAccordionSections.includes(this.config.name)
      );
    },

    collapseAriaLabel() {
      const caption = this.config.name || '';
      const phrase = this.isOpen ? this.content.collapseOptionsAbout : this.content.expandOptionsAbout;
      return `${phrase} ${caption}`;
    },

    hintId() {
      return `radio-list-filter-hint-${this._uid}`;
    }
  },

  methods: {
    ...mapActions("events", ["triggerEvent"]),
    ...mapActions("filters", ["openAccordionSection", "closeAccordionSection"]),

    toggle() {
      if (this.isOpen) {
        this.closeAccordionSection(this.config.name);
      } else {
        this.openAccordionSection(this.config.name);
      }
    },

    itemLabelId(item) {
      return `radio-list-filter-label-${this._uid}-${item.value}`;
    },

    onSelect(selectedItem) {
      if (selectedItem.value === 'relevance') {
        // Relevance = no sort — clear all selections so nothing appears checked
        this._config.items.forEach(item => { item.value !== 'relevance' ? item.selected = false : item.selected = true });
      } else {
        this._config.items.forEach(item => {
          item.selected = item === selectedItem;
        });
      }

      this.triggerEvent({
        event: `filter-toggle-event-${this.config.name}`,
        data: selectedItem
      });
    }
  }
};
</script>

<style lang="scss">
.radio-list-filter {
  display: flex;
  flex-direction: column;
  width: 100%;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    cursor: pointer;
    background: #fff;
    border-bottom: 1px solid #E5E5E5;
  }

  &__title {
    font-size: 14px;
    font-weight: 500;
    color: #000;
  }

  &__icon {
    font-size: 18px;
    line-height: 1;
    color: #000000;
    flex-shrink: 0;
  }

  &__body {
    display: flex;
    flex-direction: column;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    cursor: pointer;
    font-size: 12px;
    color: #000000;
    background: #fff;
    user-select: none;

    &:hover {
      background: #F7F7F7;
    }

    input[type="radio"] {
      appearance: none;
      -webkit-appearance: none;
      width: 16px;
      height: 16px;
      border: 1px solid #000;
      border-radius: 50%;
      cursor: pointer;
      flex-shrink: 0;
      background-color: #fff;

      &:checked {
        background-color: #18dc59;
      }
    }
  }
}
</style>
